export const SITE_URL = "https://www.armorysync.com";
export const PUBLIC_ROBOTS = "index,follow,max-image-preview:large";

export function latestContentDate(fallback, posts) {
  return posts.reduce((latest, post) => {
    const value = post.updatedAt || post.date;
    return /^\d{4}-\d{2}-\d{2}$/.test(value || "") && value > latest ? value : latest;
  }, fallback);
}

export function blogCoverAttributes(post, sizes = "(max-width: 760px) calc(100vw - 32px), 1120px") {
  const sources = (post.coverSources || []).filter((source) => source.src && source.width > 0);
  return {
    src: post.cover,
    width: post.coverWidth,
    height: post.coverHeight,
    ...(sources.length ? {
      srcSet: sources.map((source) => `${source.src} ${source.width}w`).join(", "),
      sizes,
    } : {}),
  };
}

export function blogStructuredData(post) {
  const url = `${SITE_URL}/blog/${post.slug}`;
  return {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    "@id": `${url}#article`,
    headline: post.title,
    description: post.subtitle || "ArmorySync builds practical firearm management apps like Range Pocket.",
    datePublished: post.date,
    dateModified: post.updatedAt || post.date,
    image: new URL(post.cover || "/features/feature-armory-status.webp", SITE_URL).href,
    url,
    keywords: (post.tags || []).join(", "),
    author: { "@type": "Organization", name: "ArmorySync", url: `${SITE_URL}/about` },
    publisher: {
      "@type": "Organization",
      "@id": `${SITE_URL}/#organization`,
      name: "ArmorySync",
      logo: { "@type": "ImageObject", url: `${SITE_URL}/apple-touch-icon.png` },
    },
    mainEntityOfPage: { "@type": "WebPage", "@id": url },
  };
}
